
const EMPTY = { elements: [] }

/**
 * Resolve an element's modal form to one shape.
 *
 * A modal form is declared two ways:
 *
 *   modalFormRef: 'selectFromLocationWarehouse'   a form shared by several elements
 *   modalForm:    [ …elements ]                   a form declared in place
 *
 * A `modalFormData` entry is always the object form, `{ id, elements }`, and its
 * `id` always equals its key — that is what gives a modal a name of its own
 * instead of borrowing the id of whatever opened it. `lint:components` enforces
 * it.
 *
 * A form declared in place may still be the bare array of elements, the short
 * form for `{ elements: [...] }` — the same shorthand the predicate language
 * uses when a bare array means an implicit `all`. Those twenty have no `id`, so
 * `ModalForm` falls back to the composed id of the element that opened them.
 * Giving them ids is the remaining half of task 33.1 §7 q3.
 *
 * There is one spelling. `modalGroup` survived on notification and masterDetail
 * action buttons until 2026-08-17, adapted back to `modalFormRef` at those two
 * call sites — which is exactly why the dead-entry check could not see them, and
 * why `matchPayment` looked unreferenced. Both now pass the button straight in.
 *
 * An unknown ref returns an empty form rather than throwing, so a typo shows up
 * as a modal with no fields instead of a blank page.
 */
const resolveModalForm = (item) => {
    let form

    if (item?.modalFormRef) {
        form = getModel('modalFormData')[item.modalFormRef]
        if (!form) {
            console.warn(`[resolveModalForm] modalFormRef '${item.modalFormRef}' not found in modalFormData`)
            return EMPTY
        }
    } else {
        form = item?.modalForm
    }

    if (!form) return EMPTY
    if (Array.isArray(form)) return { elements: form }
    return { elements: [], ...form }
}

export default resolveModalFormimport { getModel } from '../../model/registry'

